declare var $: any;

export default function handleHeaderPosition() {
  if($('#js-important').length){
    const top = $('#js-important').innerHeight() + 22;
    $('.p-hero--selector').css('top', top);
  }
}